<template>
  <div style="margin:0;padding:0;background-color:#fff;">
    <div style="font-family:sans-serif;color:#000;background-color:#f3f3f3;">
      <table style="margin:0 auto;width:100%;max-width:680px;border-spacing:0;border-collapse:collapse;">
        <tbody>
          <tr>
            <td style="width:20px;padding:0;">
            </td>
            <td style="padding:0;">
              <table style="font-size:13px;line-height:1;margin:0 0 22px;width:100%;border-spacing:0;border-collapse:collapse;">
                <tbody>
                  <tr>
                    <td valign="middle" style="width:82px;height:64px;">MARPH</td>
                    <td valign="middle" style="height:64px;">/ Notification</td>
                    <td valign="middle" style="text-transform:capitalize;text-align:right;height:64px;"></td>
                  </tr>
                </tbody>
              </table>
              
              <div style="margin:0 0 62px;width:100%;border-spacing:0;border-collapse:collapse;">
                <h1 style="font-size:28px;font-weight:bold;line-height:34px;letter-spacing:-0.001em;margin:0 0 12px;">{{ title }}</h1>
              </div>
              
              <table style="margin:0 0 40px;width:100%;border-spacing:0;border-collapse:collapse;">
                <tbody>
                  <tr>
                    <td align="right" style="padding:0;">
                      <div style="text-align:left;margin:0 0 43px;width:100%;max-width:476px;">
                        <p style="font-size:15px;line-height:24px;text-align:justify;white-space:pre-wrap;margin:0;">{{ text }}</p>
                      </div>
                      
                      <div style="text-align:left;margin:0 0 44px;width:100%;max-width:476px;">
                        <table style="margin:0 0 16px 0;border-spacing:0;border-collapse:collapse;">
                          <tbody>
                            <tr>
                              <td valign="center" style="font-size:19px;height:30px;padding:0 10px;background-color:#000;border-radius:15px;">
                                <a :href="url" target="_blank" style="text-decoration:none;color:#fff;">VIEW</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td style="width:20px;padding:0;"></td>
          </tr>
          <tr>
            <td colspan="3" align="center" style="height:24px;padding:0;"></td>
          </tr>
        </tbody>
      </table>
      <table style="font-family:sans-serif;color:#000;margin:0 auto;width:100%;border-spacing:0;border-collapse:collapse;">
        <tbody>
          <tr>
            <td style="width:20px;padding:0;background-color:#fff;"></td>
            <td align="center" style="padding:0;background-color:#fff;">
              <table style="width:100%;max-width:640px;border-spacing:0;border-collapse:collapse;">
                <tbody>
                  <tr>
                    <td style="height:72px;"></td>
                  </tr>
                  <tr>
                    <td style="font-size:12px;line-height:16px;padding:0;">Copyright © PR TIMES Inc. 2022</td>
                  </tr>
                  <tr>
                    <td style="height:72px;"></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td style="width:20px;padding:0;background-color:#fff;"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OctNotificationMail',
  components: {
  },
  props: {
    /** Title text */
    title: {
      type: String,
      default: ''
    },
    /** Body text */
    text: {
      type: String,
      default: ''
    },
    /** Link URL */
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    /** Returns HTML Document as string */
    toString () {
      return `
        <html xmlns="http://www.w3.org/1999/xhtml">
          <head>
            <meta name="viewport" content="width=device-width,initial-scale=1.0" />
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
            <meta name="color-scheme" content="light">
            <meta name="supported-color-schemes" content="light">
          </head>
          <body style="margin:0;padding:0;background-color:#fff">
            ${this.$el.innerHTML}
          </body>
        </html>
      `
    }
  },
}
</script>
